import { Component, Input, OnChanges, signal, SimpleChanges } from '@angular/core';
import { CargaDocumentosService } from 'src/app/Services/carga-documentos.service';

@Component({
  selector: 'app-pdfviewer-simple',
  templateUrl: './pdfviewer-simple.component.html',
  styleUrls: ['./pdfviewer-simple.component.css']
})
export class PdfviewerSimpleComponent implements OnChanges {
  @Input() url: string = '';
  pdfSrc: string | null = null;
  currentPdf = signal<string>('');
  zoom = 1;
  page = 1;
    public bigFile: boolean = false;

  constructor(private cargaDocumentosService: CargaDocumentosService,) {

  }

  ngOnChanges(changes: SimpleChanges): void {

    this.cargaDocumentosService.getUrlPdf(this.url).subscribe((base64: string) => {

      if (base64.length > 0) {
        const base64Pdf = `data:application/pdf;base64,${base64}`;
        this.currentPdf.set(base64Pdf);
        this.pdfSrc = base64Pdf;

      }
      else{
        let newUrl = this.url.replace('base64', 'url_presigned');
          console.log('Blob URL creada para grande:', newUrl);

          this.cargaDocumentosService.getUrlFile(newUrl).subscribe(
            {
              next: (respuesta) => {

                console.log(respuesta);
                this.pdfSrc = respuesta.data;
                this.bigFile = true;

              },
              error: (error: any) => {
                console.log(error);
              }
            }
          );
      }
    });
  }

  zoomIn() {
    this.zoom += 0.25;
  }

  zoomOut() {
    if (this.zoom > 0.5) this.zoom -= 0.25;
  }

  nextPage() {
    this.page++;
  }

  prevPage() {
    if (this.page > 1) this.page--;
  }

  downloadPdf() {
    if (!this.pdfSrc) return;
    const link = document.createElement('a');
    link.href = this.pdfSrc;
    link.download = 'archivo.pdf';
    link.click();
  }
}
